import { createIcon } from '@chakra-ui/react'

export const ChevronRightIcon = createIcon({
  displayName: 'ChevronRightIcon',
  viewBox: '0 0 16 16',
  path: (
    <path d='M6 12L10 8L6 4' stroke='currentColor' fill='none' strokeWidth='1.75' strokeLinecap='round' strokeLinejoin='round' />
  ),
})
